module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Cover: The Power of Pooping, by Susan Wong",
      "aria-describedby": "cover-alt",
      "role": "doc-cover",
      "src": "e9781646042845/images/9781646042845.jpg"
    }
  })]), _vm._v(" "), _c('aside', {
    attrs: {
      "hidden": "hidden",
      "id": "cover-alt"
    }
  }, [_c('p', [_vm._v("Nurse Wong from Butt Talks TV with John Rietcheck")]), _vm._v(" "), _c('p', [_vm._v("The Power of Pooping")]), _vm._v(" "), _c('p', [_vm._v("A Cheeky Diet and Lifestyle Guide to End Constipation and Transform Your Health")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2efb54c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042845/xhtml/cover.vue
// module id = 54
// module chunks = 0